import React, { useEffect, useState } from 'react';
import {
    Col,
    Container, FormCheck, FormGroup
} from 'react-bootstrap';
import '../../styles/MembersTable.css';
import { HHIEButton } from '../utility/HHIEButton';

export default function AdminFeatures(props) {
    const [features, setFeatures] = useState(null);
    const [notifications, setNotifications] = useState(false);
    const [pocNotifications, setPocNotifications] = useState(false);
    const [value, setValue] = useState(false);
    const [loading, setLoading] = useState(true);

    const handleSubmit = () => {
        var sfid = "";
        const sessionString = sessionStorage.getItem("user");
        if (sessionString !== null) {
            try {
                const user = JSON.parse(sessionString);
                sfid = user.sfid;
            }
            catch (ex) {
                console.log(ex);
            }
            for (var feature of features) {
                if (feature.name === "pocNotifications") {
                    feature.value = pocNotifications;
                }
            }
            const fetchOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(features)
            }

            fetch('api/admin/UpdateFeatures/' + sfid, fetchOptions)
                .then((response) => {
                    response.json()
                        .then((text) => {
                            var fullMessage = "Submit:\n" + text.message + ((text.errors !== null && text.errors !== "") ? ("\nErrors:\n" + test.Errors) : "");
                            alert(fullMessage);
                            window.location.href = "/admin-features";
                        })
                        .catch((error) => {
                            console.log("Submit text error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Submit response error: " + error);
                })
        }
    }

    useEffect(() => {
        fetch('api/admin/GetFeatures')
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors);
                        setFeatures(json.message);
                        for (var feature of json.message) {
                            if (feature.name === "notifications") {
                                setNotifications(feature.value);
                            }
                            else if (feature.name === "pocNotifications") {
                                setPocNotifications(feature.value);
                            }
                        }
                        setLoading(false);
                    })
                    .catch((error) => {
                        console.log("Retrieve json error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Retrieve response error: " + error);
            })
    },[props]);

    const onChange = (e, feature) => {
        setValue(!value);
        if (feature.name === "pocNotifications" && notifications) {
            feature.value = e.target.checked;
            setPocNotifications(e.target.checked);
        }
        else if (feature.name !== "pocNotifications") feature.value = e.target.checked;
        if (feature.name === "notifications") {
            setNotifications(e.target.checked);
            if (!e.target.checked) setPocNotifications(e.target.checked);
        }
        setValue(!value);
    }

    var contents = (loading) ? <>Loading</> :
        <FormGroup as={Col} className="mb-3" controlId="Enable Features" >
            {features.map((feature) => {
                if (feature.name === "pocNotifications") {
                    return <FormCheck type="checkbox"
                        key={feature.name}
                        style={{ textIndent: "10px" }}
                        id={feature.name}
                        label={feature.label}
                        checked={(notifications && pocNotifications)}
                        onChange={(e) => { onChange(e, feature) }}
                        disabled={(!notifications)} />

                }
                else {
                    return <FormCheck type="checkbox"
                        key={feature.name}
                        id={feature.name}
                        label={feature.label}
                        defaultChecked={feature.value}
                        onChange={(e) => { onChange(e, feature) }} />
                }
            })}
            <HHIEButton 
                id="feature-submit" 
                variant="secondary" 
                type="submit" 
                onClick={() => { handleSubmit() }}
                title="Submit"
            />
        </FormGroup>

    return (
        <Container>
            <br />
            <h2>Features</h2>
            Enabled Features:
            <br />
            <div>
                {contents}
            </div>
        </Container>
    )
}